//Search
export const TESTING_SCOPE_SEARCH_START_LOADING = "TESTING_SCOPE_SEARCH_START_LOADING";
export const TESTING_SCOPE_SEARCH_END_LOADING = "TESTING_SCOPE_SEARCH_END_LOADING";
export const TESTING_SCOPE_SEARCH_LOADED = "TESTING_SCOPE_SEARCH_LOADED";
export const SET_TESTING_SCOPE_FILTER = "SET_TESTING_SCOPE_FILTER";

//Edit
export const TESTING_SCOPE_START_LOADING = "TESTING_SCOPE_START_LOADING";
export const TESTING_SCOPE_END_LOADING = "TESTING_SCOPE_END_LOADING";
export const TESTING_SCOPE_LOADED = "TESTING_SCOPE_LOADED";
